<template>
  <div class="input-search">
    <div class="input-search-form">
      <a-input
        v-model="searchVal"
        :placeholder="fieldNamePlace"
        @keyup.enter="getSearchVal"
      />
      <i
        v-if="resultLists.length"
        class="iconfont iconicon-test13"
        @click="delSearchData"
      />
      <i
        v-if="!resultLists.length"
        class="iconfont iconicon-test45"
        @click="getSearchVal"
      />
    </div>
    <div
      v-if="resultLists.length"
      class="search-lists"
    >
      <a-button
        v-for="(item, index) in resultLists"
        :key="item.id"
        :disabled="item.checked"
        @click="addField(item, index)"
      >
        {{ item.fieldname }}
      </a-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import clone from 'lodash'
export default {
  data () {
    return {
      searchVal: '',
      resultLists: []
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas']),
    datas () {
      return clone(this.infoDatas)
    },
    fieldNamePlace () {
      return this.$t('message["1129"]')
    }
  },
  watch: {
    searchVal (val) {
      if (val) {
        this.resultLists = []
      }
    }
  },
  methods: {
    getSearchVal (e) {
      let { infoDatas, resultLists = [] } = this
      for (let key in infoDatas) {
        if (infoDatas[key].child && infoDatas[key].child.length) {
          infoDatas[key].child.forEach((item) => {
            if (item.fieldname.indexOf(this.searchVal) > -1) {
              resultLists.push(item)
            }
          })
        }
      }
    },
    addField (item) {
      let obj = {
        fieldkey: item.fieldkey,
        fieldtype: item.fieldtype,
        label: item.fieldname,
        isneeded: false,
        ishidden: false,
        isdelete: true,
        placeholder: '',
        isActive: false
      }
      const { fieldtype } = item
      // if (fieldtype === 'text' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'datetime' || fieldtype === 'email' || fieldtype === 'file') {
      //   obj= Object.assign(obj)
      // }
      if (fieldtype === 'checkbox' || fieldtype === 'radio') {
        item.options.forEach(item => {
          item['isshow'] = true
        })
        obj = Object.assign(obj, {
          options: item.options,
          defaultvalue: fieldtype === 'checkbox' ? [] : ''
        })
      } else if (fieldtype === 'editor') {
        obj = Object.assign(obj, {
          defaultvalue: ''
        })
      } else if (fieldtype === 'area') {
        delete obj.placeholder
        obj = Object.assign(obj, {
          defaultvalue: {},
          placeholder: {
            'select': '',
            'input': ''
          },
          fieldconfig: {
            enableforeign: 1,
            format: 1
          }
        })
      } else if (fieldtype === 'select_tree') {
        this.treeOptions(item.options)
        obj = Object.assign(obj, {
          defaultvalue: [],
          fieldconfig: {
          },
          options: item.options
        })
      } else if (fieldtype === 'select') {
        item.options.forEach(item => {
          item['isshow'] = true
        })
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          },
          options: item.options
        })
      } else if (fieldtype === 'number') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
            isallowminus: 0, isallowdecimals: 0
          }
        })
      } else if (fieldtype === 'datetime') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
            isnow: true, formatdatetime: 1
          }
        })
      } else if (fieldtype === 'file') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          }
        })
      } else {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          }
        })
      }
      if (!item.checked) {
        this.formDefaultDatas.push(obj)
        item.checked = true
      }
    },
    treeOptions (arr) {
      arr.forEach(item => {
        item['isshow'] = true
        if (item.children) {
          this.treeOptions(item.children)
        }
      })
    },
    delSearchData () {
      this.resultLists = []
    }
  }
}
</script>
<style lang="scss" scoped>
  .input-search::v-deep {
    margin: 12px 0 24px;
    .input-search-form {
      width: 100%;
      height: 32px;
      position: relative;
      .iconfont {
        position:absolute;
        right: 10px;
        top: 4px;
        color: #d8d8d8;
      }
      input {
        width: 100%;
      }
    }
    .search-lists {
      margin-top: 15px;
      .ant-btn-default {
        background: #fff;
        margin-bottom: 10px;
      }
      button[disabled] {
        background: #f7f7f7;
      }
    }
  }
</style>
